export let baseURL = process.env.REACT_APP_SERVER_URL;
